import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../state/reducer.tsx';
import { componentsBeingDeleted } from '../../state/ui/delete/selectors.tsx';
import View from './view.tsx';

const mapStateToProps = (state: State) => ({
	componentsBeingDeleted: componentsBeingDeleted(state),
});

export default connect(mapStateToProps, {})(View);
